// extracted by mini-css-extract-plugin
export default {"foodSourceTitle":"food-source-selector_foodSourceTitle__C+klR","foodSourceRadioIcon":"food-source-selector_foodSourceRadioIcon__jUNth"};